import React from 'react';

const ClientsManagerPage = () => {
    return (
        <div>
            <p>ClientManager</p>
        </div>
    );
}

export default ClientsManagerPage;
